import { EvmTxHistory, ResGetPoolDetailsAndEvmTxHistory } from '@/types';
import { useEffect, useState } from 'react';
import { useWeb3 } from '@/hooks/use-web3';
import { promiseStatus } from '@/lib/Promise';
import { GETPOOLDETAILS } from '@/lib/common/name-space';

import { Box, Typography, useTheme } from '@mui/material';
import PortfolioTable from './table/PortfolioTable';
import { evmTxHistoryList } from '@/api/evmScan/txList';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

export default function PoolHistory() {
  const [list, setList] = useState<ResGetPoolDetailsAndEvmTxHistory[] | null>(null);
  const { web3authCall, address: addr } = useWeb3();
  const { isConnected } = useWeb3AuthConnect();
  const theme = useTheme();

  useEffect(() => {
    if (list) {
      return;
    }
    (async () => {
      if (isConnected && addr) {
        if (process.env.NODE_ENV === 'development') {
          return;
        }
        const txList = await addrTxList(addr);
        if (txList === undefined || txList?.length === 0) {
          return;
        }
        await txHistory(txList);
      }
    })();
    return () => {};
  }, [web3authCall, isConnected, addr]);

  const addrTxList = async (aAddress: string) => {
    if (!web3authCall?.connected()) {
      return;
    }
    const re: EvmTxHistory[] = await evmTxHistoryList(aAddress);
    if (!re?.length) {
      return;
    }
    // evmList = re;
    return re;
  };

  const txHistory = async (aList: EvmTxHistory[]) => {
    const filter = await Promise.allSettled(
      aList
        .filter(
          (item: EvmTxHistory) =>
            item.isError === '0' &&
            (item.functionName.startsWith('stakeToken') || // 스테이킹
              item.functionName.startsWith('claimReward') || // 개별 리워드 수령
              item.functionName.startsWith('unStakeToken') || // 언스테이킹
              item.functionName.startsWith('claimAllReward') || // 스테이킹 올
              item.methodId.startsWith('0x8448705b')), // 회수???
        )
        .map(async (item: EvmTxHistory, index: number) => {
          const re = await web3authCall?.callStaking(GETPOOLDETAILS, item.to);
          return { ...item, ...re };
        }),
    );
    const result: ResGetPoolDetailsAndEvmTxHistory[] = promiseStatus(filter);
    setList(result);
  };

  return (
    <>
      {list ? (
        <Box
          sx={{
            maxWidth: '1680px',
            marginTop: '24px',
            marginBottom: '280px',
            padding: { xs: '16px 24px', md: '20px 24px' },
          }}
        >
          <Typography sx={{ marginBottom: '24px' }} variant="h3" color={theme.greyscale.darkgrey2}>
            Transaction History
          </Typography>
          <PortfolioTable aList={list} />
        </Box>
      ) : (
        <Box
          sx={{
            maxWidth: '1680px',
            marginTop: '24px',
            marginBottom: '280px',
            padding: { xs: '16px', md: '20px 24px' },
          }}
        >
          <Typography sx={{ marginBottom: '24px' }} variant="h3" color={theme.greyscale.darkgrey2}>
            Transaction History
          </Typography>
          <Box
            sx={{
              background: '#357AFF1A',
              borderRadius: '10px',
              padding: '10px',
              textAlign: 'center',
            }}
          >
            <Typography variant="subtitle1" color={theme.greyscale.darkgrey2}>
              No Transaction displayed yet
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );
}
